import { collection, doc, getDoc, getDocs, setDoc, query, where, limit, orderBy } from "firebase/firestore";

import { firestoreDb } from "../firebase";
import { CATEGORIZATIONS, COLLECTION_ID, CREATED_AT, DESC, EQUALS, PHOTO_ID, TRANSFORMATIONS } from "../constants";

const getTransformationById = async (transformationId: string) : Promise<Transformation | null> => {
  try {
    const transformation = await getDoc(doc(firestoreDb, TRANSFORMATIONS, transformationId));
    if (transformation.exists()) {
      return transformation.data() as Transformation;
    }
  } catch (error) {
    console.error("Error getting transformation by id: ", error);
  }
  return null;
}

const getLatestTransformation = async (collectionId: string) : Promise<Transformation> => {
  try {
    const transformation = await getDocs(
      query(
        collection(firestoreDb, TRANSFORMATIONS),
        where(COLLECTION_ID, EQUALS, collectionId),
        orderBy(CREATED_AT, DESC),
        limit(1)
      )
    );
    if (!transformation.empty) {
      return transformation.docs[0].data() as Transformation;
    }
  } catch (error) {
    console.error("Error getting latest transformation for collection: ", error);
  }
  return null;
}

const getCategorization = async (transformationId: string, photoId: string) : Promise<Categorization | null> => {
  try {
    const categorizationsRef = collection(firestoreDb, TRANSFORMATIONS, transformationId, CATEGORIZATIONS);
    const q = query(categorizationsRef, where(PHOTO_ID, EQUALS, photoId));
    const categorizations = await getDocs(q);
    if (categorizations.size === 1) {
      return categorizations.docs[0].data() as Categorization;
    };
  } catch (error) {
    console.error("Error getting categorization by transformation id and photo id: ", error);
  }
  return null;
}

const addTransformation = async (transformationObj: Transformation) => {
  try {
    const transformationRef = doc(collection(firestoreDb, TRANSFORMATIONS));
    await setDoc(transformationRef, {
      ...transformationObj,
      id: transformationRef.id
    });
    return transformationRef.id;
  } catch (e) {
    console.error("Error adding transformation: ", e);
  }
}

const TransformationService = {
  addTransformation,
  getTransformationById,
  getCategorization,
  getLatestTransformation
}

export default TransformationService;
